<template>
  <div id="app">
    <v-app id="inspire">
      <h2 class="mb-3">Listado de Internos</h2>
      <v-card class="pa-3">
        <v-text-field v-model="busqueda" prepend-inner-icon="mdi-magnify" label="Buscar usuario o interno..."
          dense outlined hide-details clearable class="mb-3" style="max-width: 400px;" />
        <v-data-table dense :headers="headers" :items="internosFiltrados" :items-per-page="100"
          hide-default-footer no-data-text="No se encontraron resultados" class="elevation-0"
          :footer-props="{ itemsPerPageText: 'Items por página' }">
        </v-data-table>
      </v-card>

      <!-- Funciones del teléfono -->
      <v-card class="pa-3 mt-3">
        <h3 class="mb-2">Funciones del Teléfono</h3>
        <v-simple-table dense>
          <thead>
            <tr><th>Función</th><th>Modo de uso</th></tr>
          </thead>
          <tbody>
            <tr><td>Transferencia</td><td>Presionar "XFer", marcar N° de interno, hablar y presionar XFer nuevamente.</td></tr>
            <tr><td>Captura de Teléfono de Grupo</td><td>"*" + "8" + "TECLA MARCAR"</td></tr>
            <tr><td>Captura de cualquier Teléfono</td><td>"*" + "*" + "N° de interno que suena" + "TECLA MARCAR"</td></tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busqueda: "",
      headers: [
        { text: "Usuario", value: "nombre", sortable: true },
        { text: "Interno", value: "interno", sortable: true, width: "100px" },
      ],
      internos: [
        { nombre: "AGNOLÓN, Fernando", interno: "339" },
        { nombre: "AIRSAT", interno: "5261400" },
        { nombre: "ALTAMIRA, Carlos", interno: "385" },
        { nombre: "ARIAS, Damián", interno: "388" },
        { nombre: "ASINARI, Silvio", interno: "363" },
        { nombre: "AVILA, Franco", interno: "356" },
        { nombre: "BATTAGLINO, Marcelo", interno: "314" },
        { nombre: "BLANCO, Sergio", interno: "376" },
        { nombre: "BLATTO, Andrés", interno: "367" },
        { nombre: "BOCHMAN, Pablo", interno: "332" },
        { nombre: "BOSIO, Jorge", interno: "359" },
        { nombre: "BOX RECEPCIÓN ING.", interno: "327" },
        { nombre: "CABINA TALLER", interno: "371" },
        { nombre: "CABLEADO", interno: "379" },
        { nombre: "CARAMELLO, Jorge (Insp y Ensayo)", interno: "395" },
        { nombre: "CHIAROTTO, Marcelo", interno: "383" },
        { nombre: "CIPRIANI, Carlos", interno: "316" },
        { nombre: "CONMUTADOR (Natalia)", interno: "301" },
        { nombre: "CONSULTORIO MÉDICO", interno: "334" },
        { nombre: "DAVICINO, Walter", interno: "347" },
        { nombre: "DEMICHELIS, Leonardo", interno: "333" },
        { nombre: "DENARO, Gustavo", interno: "357" },
        { nombre: "DEPÓSITO (Pañol)", interno: "308" },
        { nombre: "DEPÓSITO (Walter Villalba)", interno: "321" },
        { nombre: "ECHEVERRÍA, Anahí", interno: "387" },
        { nombre: "FERLAUTO, Juan", interno: "397" },
        { nombre: "FERRARI, Carlos", interno: "350" },
        { nombre: "GAINZA, Marcelo", interno: "370" },
        { nombre: "GAMAGGIO, Ignacio", interno: "381" },
        { nombre: "GONZALO, Nicolás", interno: "330" },
        { nombre: "GRACO, Roberto (Dr.)", interno: "334" },
        { nombre: "GRUBESIC, Mónica", interno: "335" },
        { nombre: "GUINDER, Rodrigo", interno: "396" },
        { nombre: "HIESTAND, Federico", interno: "341" },
        { nombre: "Ingeniería de Producto (libre)", interno: "386" },
        { nombre: "Laboratorio", interno: "395" },
        { nombre: "LAZCANO, Lautaro", interno: "342" },
        { nombre: "LESCANO, Rafael", interno: "354" },
        { nombre: "LINCON, Federico", interno: "342" },
        { nombre: "LÓPEZ, Fernando", interno: "391" },
        { nombre: "LUDUEÑA, Gerardo", interno: "384" },
        { nombre: "MAIDANA, Carlos", interno: "351" },
        { nombre: "MANSUR, Cecilia", interno: "311" },
        { nombre: "MOLINARI, Marcelo", interno: "317" },
        { nombre: "MONINA, Alejandro", interno: "349" },
        { nombre: "MONTENEGRO, Sonia", interno: "300" },
        { nombre: "MUSSO, Marcos", interno: "331" },
        { nombre: "OFICINA DE PERSONAL", interno: "335 / 336" },
        { nombre: "PALETTI, Remo", interno: "336" },
        { nombre: "PAÑOL", interno: "384" },
        { nombre: "PEREZ, Gustavo", interno: "320" },
        { nombre: "PLANTA II", interno: "377 / 378" },
        { nombre: "POSTIGO, Gabriel", interno: "312" },
        { nombre: "PRETINI, Claudio", interno: "366" },
        { nombre: "PRETINI, Juan", interno: "360" },
        { nombre: "PRETINI, Mauro", interno: "307" },
        { nombre: "PRIETO, María Luisa", interno: "353" },
        { nombre: "QUIROZ, Victor", interno: "382" },
        { nombre: "Reclamos Sist. Airsat", interno: "5261400" },
        { nombre: "REDONDO, Federico", interno: "392" },
        { nombre: "RODRIGUEZ, Matías", interno: "321" },
        { nombre: "RODRIGUEZ, Tomás", interno: "352" },
        { nombre: "SALA Reun. Obras", interno: "337" },
        { nombre: "SALA Capacitación", interno: "322" },
        { nombre: "SALA Reun. (Administr.) P.Alta", interno: "324" },
        { nombre: "SALA Reunión Comercial", interno: "329" },
        { nombre: "SALA Reunión Ventas", interno: "323" },
        { nombre: "Sistemas", interno: "355" },
        { nombre: "SLUPKO, Natalia", interno: "301" },
        { nombre: "SORUCO, Hernan", interno: "393" },
        { nombre: "STEIN, Rodrigo", interno: "340" },
        { nombre: "SUAREZ, Sebastián", interno: "343" },
        { nombre: "TALLER ELÉCTRICO", interno: "375" },
        { nombre: "TALLER MECÁNICO", interno: "372" },
        { nombre: "TAMOLA, Ariel", interno: "319" },
        { nombre: "TRIVES, Mariano", interno: "368" },
        { nombre: "VEGA, Pablo", interno: "325" },
        { nombre: "VILLALBA, Walter", interno: "321" },
        { nombre: "VILLAGRA, Cristian", interno: "389" },
        { nombre: "YACCI, Claudia", interno: "310" },
        { nombre: "ZARZA, Gonzalo", interno: "394" },
        { nombre: "ZUPPA, Fabricio", interno: "348" },
      ],
    };
  },
  computed: {
    internosFiltrados() {
      if (!this.busqueda) return this.internos;
      const q = this.busqueda.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return this.internos.filter((i) => {
        const nombre = i.nombre.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const interno = i.interno.toLowerCase();
        return nombre.includes(q) || interno.includes(q);
      });
    },
  },
};
</script>
